import React from "react";
import ListingFooter from "../../../../../layout/components/footer/ListingFooter";
import LastRefreshTime from "./LastRefreshTime";
const DashboardFooter = ({ lastRefreshTime, paginationProps = null }) => {
    return (React.createElement(ListingFooter, { parentClass: "dashboard-footer", leftComponent: React.createElement(LastRefreshTime, { lastRefreshTime: lastRefreshTime }), paginationProps: paginationProps }));
};
export default DashboardFooter;
